var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 94c25.957 0 47-21.043 47-47S72.957 0 47 0 0 21.043 0 47s21.043 47 47 47Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m29.6 60-7.1 19.4c-.5 1.4 1 2.7 2.3 2.1l4.3-2.1c.9-.4 1.9 0 2.3.8l1.9 4.4c.6 1.4 2.6 1.3 3.1-.1l7.1-19.4",
    fill: "#FF6F6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.6 60-7.1 19.4c-.5 1.4 1 2.7 2.3 2.1l4.3-2.1c.9-.4 1.9 0 2.3.8l1.9 4.4c.6 1.4 2.6 1.3 3.1-.1l7.1-19.4",
    stroke: "#E05F5F",
    strokeWidth: 3.356,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m64.4 60 7.1 19.4c.5 1.4-1 2.7-2.3 2.1L65 79.4c-.9-.4-1.9 0-2.3.8l-1.9 4.4c-.6 1.4-2.6 1.3-3.1-.1l-7.1-19.4",
    fill: "#FF6F6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m64.4 60 7.1 19.4c.5 1.4-1 2.7-2.3 2.1L65 79.4c-.9-.4-1.9 0-2.3.8l-1.9 4.4c-.6 1.4-2.6 1.3-3.1-.1l-7.1-19.4",
    stroke: "#E05F5F",
    strokeWidth: 3.356,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71c16.016 0 29-12.984 29-29S63.016 13 47 13 18 25.984 18 42s12.984 29 29 29Z",
    fill: "#D5EFF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m48.7 24.3 4.2 8.5c.3.5.8.9 1.4 1l9.4 1.4c1.5.2 2.1 2.1 1 3.2L57.9 45c-.4.4-.6 1-.5 1.6l1.6 9.3c.3 1.5-1.3 2.7-2.7 1.9l-8.4-4.4c-.5-.3-1.2-.3-1.7 0l-8.4 4.4c-1.4.7-2.9-.4-2.7-1.9l1.6-9.3c.1-.6-.1-1.2-.5-1.6l-6.8-6.6c-1.1-1.1-.5-2.9 1-3.2l9.4-1.4c.6-.1 1.1-.5 1.4-1l4.2-8.5c.6-1.4 2.6-1.4 3.3 0Z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.023
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel4);
export default __webpack_public_path__ + "static/media/level4.8a18d883.svg";
export { ForwardRef as ReactComponent };